export default __webpack_public_path__ + "static/media/yearbook.30c6419a.svg";